import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { getPublicPackage } from "./publicPackagesApi";

export const usePublicPackage = () => {
  const { packageId } = useParams<{ packageId: string }>();
  if (!packageId) {
    throw new Error("usePublicPackage requires a packageId route param");
  }
  const { data, isLoading } = useQuery({
    queryKey: ["public", "packages", packageId],
    queryFn: ({ signal }) => getPublicPackage(packageId, signal),
  });

  return { data, isLoading };
};
